import React, { useState, useEffect, useCallback } from 'react';
import { Alert, Badge, Button, Spinner, Table } from 'reactstrap';
import { get } from '../hooks/apiFetch';

export const LoginLogoutTab = () => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [lastLogId, setLastLogId] = useState(null);
    const [hasMoreLogs, setHasMoreLogs] = useState(true);
    const [unauthorized, setUnauthorized] = useState(false);

    const loadLogs = useCallback(async () => {
        setLoading(true);
        setError(null);
        setUnauthorized(false);

        try {
            const take = 50;
            const url = `/api/admin/LoginLogoutDb/GetChunk?lastId=${encodeURIComponent(lastLogId)}&take=${encodeURIComponent(take)}`;
            const data = await get(url);

            if (!Array.isArray(data)) {
                throw new Error('Неверный формат данных от сервера');
            }

            setLogs(prev => [...prev, ...data]);

            if (data.length > 0) {
                setLastLogId(data[data.length - 1].id);
            }

            setHasMoreLogs(data.length === take);
        } catch (e) {
            setError(e.message || 'Ошибка загрузки логов');
        } finally {
            setLoading(false);
        }
    }, [lastLogId]);

    useEffect(() => {
        loadLogs();
    }, []); // initial mount

    const formatDateTime = useCallback((dateTimeString) => {
        if (!dateTimeString) return '';
        return new Date(dateTimeString).toLocaleString();
    }, []);

    const renderStatusBadge = useCallback((log) => {
        if (log.isBlocked) {
            return <Badge color="danger">Заблокирован</Badge>;
        }

        return log.isSuccessful ? (
            <Badge color="success">Успешно</Badge>
        ) : (
            <Badge color="warning">Ошибка</Badge>
        );
    }, []);

    if (unauthorized) {
        return (
            <div className="text-center my-5">
                <Alert color="danger">
                    <h4>Ошибка авторизации</h4>
                    <p>{error}</p>
                    <Button onClick={() => window.location.reload()}>
                        Обновить страницу
                    </Button>
                </Alert>
            </div>
        );
    }

    if (loading && logs.length === 0) {
        return (
            <div className="text-center my-5">
                <Spinner color="primary" />
                <p>Загрузка логов авторизации...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="text-center my-5">
                <Alert color="danger">
                    <h4>Ошибка</h4>
                    <p>{error}</p>
                    <Button onClick={loadLogs}>
                        Попробовать снова
                    </Button>
                </Alert>
            </div>
        );
    }

    return (
        <div className="mt-3">
            <div className="table-responsive">
                <Table striped>
                    <thead>
                        <tr>
                            <th>Дата/Время</th>
                            <th>Пользователь</th>
                            <th>Статус</th>
                            <th>IP адрес</th>
                            <th>Сообщение</th>
                        </tr>
                    </thead>

                    <tbody>
                        {logs.map((log, index) => (
                            <tr key={log.id || index}>
                                <td>{formatDateTime(log.attemptTime)}</td>
                                <td>{log.login}</td>
                                <td>{renderStatusBadge(log)}</td>
                                <td>{log.ipAddress || 'Неизвестно'}</td>
                                <td>
                                    {log.message && (
                                        <small className="text-muted">
                                            {log.message}
                                        </small>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            {loading && (
                <div className="text-center my-3">
                    <Spinner color="primary" />
                    <p>Загрузка...</p>
                </div>
            )}

            {hasMoreLogs && !loading && (
                <div className="text-center my-3">
                    <Button onClick={loadLogs}>
                        Загрузить еще
                    </Button>
                </div>
            )}
        </div>
    );
};